import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {
  id: number;
};
export type UnlistCarResponse = {
  data: Car;
};

export const useUnlistCar = createMutation<
  UnlistCarResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/cars/${variables.id}/unlist`,
      method: 'PUT',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
